import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	constructor(private snackBar: MatSnackBar) { }

	open(message: string, action: string = 'Dismiss') {

		this.snackBar.open(message, action, {
			duration: 3000,
			verticalPosition: 'top',
		});
	}

	warning(message: string, duration: number = 3000) {
		this.snackBar.open(message, 'Close', {
			duration: duration,
			verticalPosition: 'top',
		});
	}
}
